import { initialize } from '@doordash/lib-i18n'
import { InitializeConfig } from '@doordash/lib-i18n/dist/types'
import { TranslationStringKey } from 'translationTypes'
import * as i18n_config from './translations/i18n_config.json'
import {
  changeLocaleToSources,
  customDetectorConfig,
  getCurrentLocaleFromSources,
} from './routes/customDetectors'

const config: InitializeConfig = {
  ...customDetectorConfig,
  ...i18n_config,
}

const i18n = initialize(config, 'app-dasher')

/**
 * Overide changeLocale and getCurrentLocale
 */
export default {
  ...i18n,
  t: (key: TranslationStringKey, options?: {}) => i18n.t(key, options),
  changeLocale: changeLocaleToSources,
  getCurrentLocale: getCurrentLocaleFromSources,
}
